module.exports = __webpack_public_path__ + "img/cloud1-1.39657e8f.png";